module.exports = __webpack_public_path__ + "static/media/invite-intro-screen.525c0e6b.svg";